import { render, staticRenderFns } from "./hsbcJudgeAccount.vue?vue&type=template&id=13e8cb5d&scoped=true"
import script from "./hsbcJudgeAccount.vue?vue&type=script&lang=js"
export * from "./hsbcJudgeAccount.vue?vue&type=script&lang=js"
import style0 from "./hsbcJudgeAccount.vue?vue&type=style&index=0&id=13e8cb5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e8cb5d",
  null
  
)

export default component.exports